import { Injector, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AssociationController } from 'src/features/common/association/association.controller';
import { ApiHelper } from 'cad/common/services/api/api-helper';
import { AssociationApi } from 'src/features/common/association/association-api';

@Injectable()
export class PhysicalLocationForecastSegmentsApi implements AssociationApi {
  private readonly endpoint: string = 'physical/location/';
  private readonly suffix: string = '/forecast/segment';

  static createAssociationApi(
    apiHelper: ApiHelper,
    associationController: AssociationController,
    injector: Injector,
  ): AssociationApi {
    return new PhysicalLocationForecastSegmentsApi(apiHelper);
  }

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (meterSegment: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + meterSegment.pointCd + this.suffix + '/' + meterSegment.meterCd);
  }

  public save = (segs: any): Observable<any> => {
    return this.apiHelper.request(this.endpoint + segs[0].pointCd + this.suffix, { body: segs });
  }
}
